module.exports = __webpack_public_path__ + "img/z13.beddb287.png";